import { useCallback, useState } from "react";
import { ROUTES as API_ROUTES } from "../../constants/api";
import { PostApiWorkflowData } from "../../api/general";
import useErrorModal from "../useErrorModal";

// types
import type {
  SendMoneyValidateExistingRecipientRequest,
  SendMoneyValidateWorkflowRequest,
  SendMoneyValidateWorkflowResponse,
} from "../../types/api/sendMoney";

type ValidateWorkflowBody = SendMoneyValidateWorkflowRequest | SendMoneyValidateExistingRecipientRequest;

export interface ValidateWorkflowResult {
  status: number;
  result: SendMoneyValidateWorkflowResponse["result"];
}
const useValidateWorkflow = () => {
  const openErrorModal = useErrorModal();
  const [loading, setLoading] = useState(false);

  const validateWorkflow = useCallback(
    async (body: ValidateWorkflowBody): Promise<ValidateWorkflowResult | null> => {
      try {
        setLoading(true);
        const response = await PostApiWorkflowData<ValidateWorkflowBody, SendMoneyValidateWorkflowResponse>(
          API_ROUTES.SEND_MONEY.VALIDATE_WORKFLOW,
          body
        );
        return { status: response.status, result: response.data.result };
      } catch (err) {
        openErrorModal(err);
        return null;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { loading, validateWorkflow };
};

export default useValidateWorkflow;